import { useState } from 'react';

function QueryTool() {
  // Hardcoded practice data
  const practiceData = [
    { name: "Acevedo Montebello", practiceId: "Acevedo1" },
    { name: "Acevedo Ontario", practiceId: "Acevedo2" },
    { name: "Varinos", practiceId: "Jemin" },
    { name: "Legacy Dental", practiceId: "LegacyDental" },
    { name: "Restorative Dentists", practiceId: "practice-1739995683291" },
    { name: "Missiion Dental Group (Growney)", practiceId: "Growney1" },
    { name: "Nova Dental", practiceId: "practice-1740507110470" },
    { name: "PDM Taunton", practiceId: "practice-1741361787158" },
    { name: "PDM Westborough", practiceId: "practice-1741361787159" },
    { name: "Moutainside", practiceId: "practice-1743516733007" },
    { name: "NKC", practiceId: "nkc1" },
    { name: "Chua Dental", practiceId: "practice-1745267950238" },
    { name: "PDM Smileland", practiceId: "practice-1746751847834" },
    { name: "PDM Norwood", practiceId: "practice-1746751847834" },
    { name: "South Corona", practiceId: "practice-1747774043722" },
    { name: "Smile Max 365", practiceId: "practice-1747950616466" },
    { name: "South Jersey Pediatric", practiceId: "practice-1748442372306" },
    { name: "Happy Tooth Dental", practiceId: "practice-1747851038316" },
    { name: "Olympua Advanced Dentistry", practiceId: "practice-1744917033510" },
    { name: "Laguna Dental", practiceId: "practice-1747770079425" },
    { name: "Kiddos", practiceId: "practice-1749073417083" },
    { name: "Brooks (Hawaii)", practiceId: "practice-1747245677972" },
    { name: "Chandler Dental", practiceId: "practice-1747766430371" },
    { name: "Lifetime Dental", practiceId: "practice-1750971787413" },
    { name: "Smiles Dental", practiceId: "Sams Practice" }
  ];
  

  const [searchTerm, setSearchTerm] = useState('');
  const [copiedId, setCopiedId] = useState('');

  // Filter practices based on search term
  const filteredPractices = practiceData.filter(practice =>
    practice.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    practice.practiceId.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Copy practice ID to clipboard
  const copyToClipboard = async (practiceId) => {
    try {
      await navigator.clipboard.writeText(practiceId);
      setCopiedId(practiceId);
      setTimeout(() => setCopiedId(''), 2000); // Clear after 2 seconds
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <div className="tab-content">
      <h1>Query Tool</h1>
      
      <div className="query-tool-container">
        {/* Search Section */}
        <div className="search-section">
          <div className="form-group">
            <label htmlFor="search-input">Search Practices:</label>
            <input
              type="text"
              id="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search by practice name or ID..."
              className="search-input"
            />
          </div>
        </div>

        {/* Results Section */}
        <div className="results-section">
          <div className="results-header">
            <h2>Practice Data</h2>
            <span className="result-count">
              {filteredPractices.length} of {practiceData.length} practices
            </span>
          </div>
          
          {filteredPractices.length > 0 ? (
            <div className="practice-list">
              <table className="practice-table">
                <thead>
                  <tr>
                    <th>Practice ID</th>
                    <th>Practice Name</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPractices.map((practice, index) => (
                    <tr key={practice.practiceId}>
                      <td className="practice-id">
                        <span 
                          className={`clickable-practice-id ${copiedId === practice.practiceId ? 'copied' : ''}`}
                          onClick={() => copyToClipboard(practice.practiceId)}
                          title="Click to copy"
                        >
                          {practice.practiceId}
                          {copiedId === practice.practiceId && <span className="copy-indicator"> ✓ Copied!</span>}
                        </span>
                      </td>
                      <td className="practice-name">{practice.name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="no-results">
              <p>No practices found matching your search criteria.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default QueryTool; 